import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Téléphone au FORMAT AUTOMATIQUE (123) 456-7890 (demande du propriétaire,
// 2026-10-22 — « tous les numéros de téléphone ») : pendant la frappe, les
// chiffres tapés se rangent tout seuls ; un « 1 » initial (1-514-…) est ignoré.
export function formatPhone(v) {
  let d = String(v || "").replace(/\D/g, "");
  if (d.length === 11 && d.startsWith("1")) d = d.slice(1);
  d = d.slice(0, 10);
  if (d.length > 6) return `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}`;
  if (d.length > 3) return `(${d.slice(0, 3)}) ${d.slice(3)}`;
  return d ? `(${d}` : "";
}
